const find = <E extends Element = Element>(selector: string) => document.querySelector(selector) as E;

export default {
  getAll() {
    return {
      $username: find<HTMLInputElement>('#ForgotLogin_Username'),
      $resetLink: find<HTMLButtonElement>('#tn-account-login-forgot-login-link'),
      $form: find<HTMLFormElement>('#tn-account-login-forgot-password-form'),
      $inputLoginEmail: find<HTMLInputElement>('#PatronAccountLogin_Username'),
      $errorMessage: find<HTMLDivElement>('#tn-account-login-forgot-password-failure-message'),
    };
  },
};
